import { useSectionsEditorState } from 'hooks/useSectionsEditorState';

export const useSectionsFormDidSucceed = () => {
  const { submitDidSucceed } = useSectionsEditorState();

  return submitDidSucceed;
};
